import React, { Fragment } from 'react';
import ControlledExpansionPanels from '../../../../components/ControlledExpansionPanels/ControlledExpansionPanels';
import ControlledCard from '../../../../components/ControlledCard/ControlledCard';
import Grid from '@material-ui/core/Grid';

const StaticDisplayPrograms = () => {

    const GridRow1 = () => {
        return (
            <React.Fragment>
                <Grid item xs={4}>
                <ControlledCard  avatarText="B" title="BSc (Politics & International Relations)" hideExpandAction  hideButtonAction/>
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="B" title="BSc (Accounting & Finance)" hideExpandAction  hideButtonAction />
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="B" title="BSc (Business Administration – BBA)" hideExpandAction  hideButtonAction/>
                </Grid>
            </React.Fragment>
        );
    }

    const GridRow2 = () => {
        return (
            <React.Fragment>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="B" title="BSc (Business & Management)" hideExpandAction  hideButtonAction/>
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="B" title="BSc (Economics)" hideExpandAction  hideButtonAction />
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="B" title="BSc (Economics & Management)" hideExpandAction  hideButtonAction/>
                </Grid>
            </React.Fragment>
        );
    }

    const GridRow3 = () => {
        return (
            <React.Fragment>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="B" title="BSc (Management & Digital Innovation )" hideExpandAction  hideButtonAction/>
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="B" title="BSc (International Relations)" hideExpandAction   hideButtonAction />
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="I" title="International Foundation Programme (IFP)" hideExpandAction  hideButtonAction/>
                </Grid>
            </React.Fragment>
        );
    }

    const GridRow4 = () => {
        return (
            <React.Fragment>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="C" title="CertHE Business Administration" hideExpandAction  hideButtonAction/>
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="C" title="CertHE Social Sciences (CHESS)" hideExpandAction  hideButtonAction />
                </Grid>
              
            </React.Fragment>
        );
    }

    const summary = <Grid container spacing={2}>
        <Grid container item xs={12} spacing={2}>
            <GridRow1 />
        </Grid>
        <Grid container item xs={12} spacing={2}>
            <GridRow2 />
        </Grid>
        <Grid container item xs={12} spacing={2}>
            <GridRow3 />
        </Grid>
        <Grid container item xs={12} spacing={2}>
            <GridRow4 />
        </Grid>
    </Grid>;

    const GridRow01 = () => {
        return (
            <React.Fragment>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="L" title="LLB" hideExpandAction  hideButtonAction/>
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="C" title="CertHE Common Law" hideExpandAction  hideButtonAction />
                </Grid>
                <Grid item xs={4}>
                    <ControlledCard  avatarText="G" title="Graduate Diploma in Commercial Law" hideExpandAction  hideButtonAction />
                </Grid>
                
            </React.Fragment>
        );
    }

    const GridRow02 = () => {
        return (
            <React.Fragment>
               
            </React.Fragment>
        );
    }

    const summary2 = <Grid container spacing={2}>
        <Grid container item xs={12} spacing={2}>
            <GridRow01 />
        </Grid>
        <Grid container item xs={12} spacing={2}>
            <GridRow02 />
        </Grid>
    </Grid>;

    return (
        <Fragment>
            <div style={{
                paddingBottom: 10, width: '90%',
                marginLeft: '4%'
            }}>
                <center>
                    <ControlledExpansionPanels title="School of Economics and Management"
                        summary={summary}
                    />
                    <ControlledExpansionPanels title="School of Law"
                        summary={summary2}
                    />
                </center>
            </div >
        </Fragment>
    );
}

export default StaticDisplayPrograms;